import React, { useState, useEffect } from "react";
import Card from "../../../components/card/Card";


import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { GetInvestigatorModule,selectInvestigatorModule } from "../../../features/learning/InvestigatorSlice";
import InvestigatorsModuleEdit from "../admin/InvestigatorsModuleEdit";

const title: String = "Investigators Modules";


const Investigators = () => {
  const InvestigatorModule = useAppSelector(selectInvestigatorModule);
  const dispatch = useAppDispatch();
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  useEffect(() => {
    var data={
      keyword:"",
      offset:0,
      companyId:userDetailsJson.companyId
    }
    // async function fetchLearningModuleData() {      
    //   let sample = await dispatch(GetInvestigatorModule(data));     
    // }   
    // fetchLearningModuleData();
    dispatch( GetInvestigatorModule(data))
  }, [dispatch]);
 
   const rowLearnArrayData=InvestigatorModule?.slice(0, 4)
   const Docslist:any = rowLearnArrayData;
   //alert(Docslist)
   const fetchLearningModuleData=()=> {    
    var data={
      keyword:"",
      offset:0
    }  
     dispatch(GetInvestigatorModule(data));    
  }
  return (
    <>
      <Card 
        type={2} 
        title={title} 
        data={Docslist} 
        fetchLearningModuleData={fetchLearningModuleData}
        modal={
          <>
            <InvestigatorsModuleEdit  />
          </>
         }
        // modal= {<HelpDocumentsModulesEdit data={InvestigatorModule} />}
        modalLink="VIEW" 
      />
    </>
  );
};

export default Investigators;
